import type { MessageKey } from "@wato/i18n";

interface QuickAction {
  readonly id: string;
  /** Path relative to /w/:id. */
  readonly to: string;
  readonly label: MessageKey;
  /** Hidden unless the member holds this permission. */
  readonly permission: string;
}

/** OWN-150a: home shortcuts row, in display order. */
export const QUICK_ACTIONS: readonly QuickAction[] = [
  {
    id: "newBroadcast",
    to: "broadcasts/new",
    label: "dashboard.home.quickActions.newBroadcast",
    permission: "broadcasts.create",
  },
  {
    id: "openInbox",
    to: "conversations",
    label: "dashboard.home.quickActions.openInbox",
    permission: "inbox.view",
  },
  {
    id: "newFlow",
    to: "flows",
    label: "dashboard.home.quickActions.newFlow",
    permission: "flows.create",
  },
  {
    id: "trainAi",
    to: "ai",
    label: "dashboard.home.quickActions.trainAi",
    permission: "ai_agents.edit",
  },
  {
    id: "connectChannel",
    to: "channels",
    label: "dashboard.home.quickActions.connectChannel",
    permission: "channels.edit",
  },
];
